import { fetchAll } from './fetch';

export default fetchAll('parameter', { apiUrl: process.env.REACT_APP_API_URL });
